import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function WarningIcon(props, ref) {
  return /*#__PURE__*/_jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: ref,
    ...props,
    children: [/*#__PURE__*/_jsx("path", {
      d: "M12.713 17.713A.97.97 0 0 1 12 18a.97.97 0 0 1-.713-.288A.97.97 0 0 1 11 17q0-.424.287-.712A.97.97 0 0 1 12 16q.424 0 .713.288.287.287.287.712 0 .424-.287.712m0-3.999A.97.97 0 0 1 12 14a.97.97 0 0 1-.713-.287A.97.97 0 0 1 11 13V9q0-.424.287-.713A.97.97 0 0 1 12 8q.424 0 .713.287Q13 8.576 13 9v4q0 .424-.287.713"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      d: "M10.264 3.039c.767-1.344 2.705-1.344 3.472 0l8.554 14.969c.762 1.333-.2 2.992-1.736 2.992H3.446c-1.535 0-2.498-1.659-1.736-2.992zM3.446 19 12 4.031 20.554 19z",
      clipRule: "evenodd"
    })]
  });
}
;
WarningIcon.displayName = "WarningIcon";
export default forwardRef(WarningIcon);